import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpened: false,
  content: "" /* example => İlan <strong>Kaş Satılık Evler</strong> favori listenizden çıkarıldı. */,
  isBackButtonVisible: true,
};

export const stickyInfoBar = createSlice({
  name: "stickyInfoBar",
  initialState,
  reducers: {
    triggerInfoBarOpened: (state, action) => {
      state.isOpened = !state.isOpened;
    },
    triggerBackButtonVisibility: (state, action) => {
      state.isBackButtonVisible = action.payload;
    },
    handleStickyContent: (state, action) => {
      state.content = action.payload;
    },
  },
});

export const { triggerInfoBarOpened, triggerBackButtonVisibility, handleStickyContent } = stickyInfoBar.actions;

export default stickyInfoBar.reducer;
